import "./PriceOfferDataSourceModal.css";

import Draggable from "react-draggable";

import DatasetLinkedOutlinedIcon from "@mui/icons-material/DatasetLinkedOutlined";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import KsprButton from "components/UI/buttons/KsprButton";
import useNavigateToKatsViewerRow from "pages/EstimateViewer/KatsViewer/hooks/useNavigateToKatsViewerRow";

const PriceOfferDataSourceModal = ({ setVisible, dataObj }) => {
	const { openKatsRowByResId } = useNavigateToKatsViewerRow({ projectId: dataObj.project_id, katsId: dataObj.kats_id });

	let isActive = false;
	if (dataObj.project_id) {
		isActive = true;
	}

	const navigateToSourceObj = () => {
		if (!isActive) return;
		openKatsRowByResId({ resId: dataObj.source_resource_id });
	};

	return (
		<Draggable handle=".PriceOfferDataSourceModalTitle">
			<Dialog
				className="PriceOfferDataSourceModal"
				sx={{ "& .MuiDialog-paper": { width: "28vw", maxWidth: "28vw", height: "280px" } }}
				open
				slotProps={{ backdrop: { style: { backgroundColor: "transparent" } } }}
			>
				<DialogTitle className="PriceOfferDataSourceModalTitle">Источник данных</DialogTitle>
				<DialogContent className="PriceOfferDataSourceModalContent">
					<table className="PriceOfferDataSourceInfoTable">
						<tbody className="PriceOfferDataSourceInfo">
							<tr>
								<td>Наименование стройки (объекта): </td>
								<td>{dataObj.project_name}</td>
							</tr>
							<tr>
								<td>Регион (ценовая зона) объекта:</td>
								<td>{dataObj.project_price_zone_name}</td>
							</tr>
							<tr>
								<td>Текущий уровень цен:</td>
								<td>{dataObj.price_level}</td>
							</tr>
							<tr>
								<td>Автор проекта:</td>
								<td>{dataObj.username}</td>
							</tr>
							<tr>
								<td>Перейти к проекту</td>
								<td>
									<div className="SourceLink" active={String(isActive)} onClick={() => navigateToSourceObj()}>
										<DatasetLinkedOutlinedIcon />
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</DialogContent>
				<DialogActions>
					<div className="MonitorModalbtnWrapper">
						<KsprButton sx={{ ml: "auto" }} variant="text" label="закрыть" onClick={() => setVisible(false)} />
					</div>
				</DialogActions>
			</Dialog>
		</Draggable>
	);
};

export { PriceOfferDataSourceModal };
